export default __webpack_public_path__ + "static/media/main.bbe1f686.png";